import React from 'react';

const AppDownload = () => {
  const InitialContent = React.useCallback(() => (
    <React.Fragment>
      <p className="text-center">
        アプリをダウンロードすると、すぐに使い始められます。
      </p>
      <div className="text-center">
        <a href="/apps/ios" className="btn-app-download" target="_blank">
          <img
            src="/assets2019/img/top/badge-lrg.png"
            srcSet="/assets2019/img/top/badge-lrg@2x.png 2x,/assets2019/img/top/badge-lrg@3x.png 3x"
            alt=""
            className="sp-img-w100 p-2"
          />
        </a>
        <a href="/apps/android" className="btn-app-download" target="_blank">
          <img
            src="/assets2019/img/top/ja_badge_web_generic.png"
            srcSet="/assets2019/img/top/ja_badge_web_generic@2x.png 2x,/assets2019/img/top/ja_badge_web_generic@3x.png 3x"
            alt=""
            className="sp-img-w100"
          />
        </a>
      </div>
    </React.Fragment>
  ));

  return (
    <React.Fragment>
      <InitialContent />
    </React.Fragment>
  );
};

export default AppDownload;
